import { render, staticRenderFns } from "./CancelBooking.vue?vue&type=template&id=64fc9822"
import script from "./CancelBooking.vue?vue&type=script&lang=js"
export * from "./CancelBooking.vue?vue&type=script&lang=js"
import style0 from "./CancelBooking.vue?vue&type=style&index=0&id=64fc9822&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fc9822')) {
      api.createRecord('64fc9822', component.options)
    } else {
      api.reload('64fc9822', component.options)
    }
    module.hot.accept("./CancelBooking.vue?vue&type=template&id=64fc9822", function () {
      api.rerender('64fc9822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/CancelBooking.vue"
export default component.exports